import React from 'react';
import { Box, Button } from '@mui/material';

interface ActionButtonsProps {
  onNewPlan: () => void;
  onRefresh: () => void;
  onImport: () => void;
  onExport: () => void;
  fileInputRef: React.RefObject<HTMLInputElement | null>;
  onFileImport: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  onNewPlan,
  onRefresh,
  onImport,
  onExport,
  fileInputRef,
  onFileImport,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, mb: 3, justifyContent: 'center' }}>
      <Button variant="outlined" onClick={onNewPlan} sx={{ mr: 1 }}>
        New Plan
      </Button>
      <Button variant="outlined" onClick={onRefresh} sx={{ mr: 1 }}>
        Refresh
      </Button>
      <Button variant="outlined" onClick={onImport} sx={{ mr: 1 }}>
        Import
      </Button>
      <Button variant="contained" onClick={onExport}>
        Export
      </Button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        style={{ display: 'none' }}
        onChange={onFileImport}
      />
    </Box>
  );
};
